import type {
  ColumnFilter,
  DecoratedUnisonProjectTask,
} from '@witmetrics/utils';
import { COMPARISON_OPERATORS } from '@witmetrics/utils/constants';
import { sortByDueAt } from '@witmetrics/utils/arrays';
import { buildColumnFilter } from '@witmetrics/utils/filters';
import { API } from '@/api';
import { PAGE_SIZE } from './constants';

const { IN, EQUALS } = COMPARISON_OPERATORS;

export const classes = {
  list: 'max-h-[500px] overflow-auto w-full px-2',
};

export async function fetchTasks(
  practiceId: number,
  userId: number,
  isShowingAll: boolean
) {
  let filters: ColumnFilter[] = [
    buildColumnFilter('isResolved', IN.value, [false]),
  ];
  if (!isShowingAll) {
    filters.push(buildColumnFilter('assignedTo', EQUALS.value, userId));
  }
  return (
    await API.Practices.fetchPracticeUnisonProjectTasks(practiceId, {
      pagination: { page: 1, pageSize: PAGE_SIZE },
      sorting: { sortBy: 'dueAt', sortOrder: 'ASCENDING' },
      filters,
    })
  ).results;
}

export function filterTasks(
  tasks: DecoratedUnisonProjectTask[],
  userId: number,
  isShowingAll: boolean
) {
  return sortByDueAt(
    tasks.filter(({ task }) => {
      return (
        !task.isResolved && (isShowingAll || task.assignedTo.id === userId)
      );
    })
  ).slice(0, PAGE_SIZE);
}

export function getViewAllFilters(
  userId: number,
  isShowingAll: boolean
): ColumnFilter[] {
  return [
    buildColumnFilter('assignedTo', IN.value, isShowingAll ? [] : [userId]),
  ];
}
